var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextQuotesOpen = function SvgTextQuotesOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5753 7.11771C17.4691 7.89601 16.5597 8.93331 15.9349 10.1411C16.274 10.0476 16.6312 9.99771 17 9.99771C19.2091 9.99771 21 11.7886 21 13.9977C21 16.2069 19.2091 17.9977 17 17.9977C14.791 17.9977 13 16.2073 13 13.998C13 10.4762 14.7505 7.36331 17.4245 5.48201C17.8762 5.16421 18.4999 5.27281 18.8177 5.72451C19.1355 6.17621 19.027 6.80001 18.5753 7.11771ZM8.5753 7.11771C7.4691 7.89601 6.5597 8.93331 5.9349 10.1411C6.274 10.0476 6.6312 9.99771 7 9.99771C9.2091 9.99771 11 11.7886 11 13.9977C11 16.2069 9.2091 17.9977 7 17.9977C4.791 17.9977 3 16.2073 3 13.998C3 10.4762 4.7505 7.36331 7.4245 5.48201C7.8762 5.16421 8.5 5.27281 8.8177 5.72451C9.1355 6.17621 9.027 6.80001 8.5753 7.11771Z",
    fill: "#1D1E1F"
  })));
};
export default SvgTextQuotesOpen;